import { render, staticRenderFns } from "./MdCommandSetupPanel.vue?vue&type=template&id=59c19fd9&"
import script from "./MdCommandSetupPanel.vue?vue&type=script&lang=js&"
export * from "./MdCommandSetupPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports